import { cx } from '@platform/core/lib/cx';
import type { ISystemPageProps } from './ISystemPageProps';
import './system.css';

/**
 * Сторінка системного модуля «Адміністрування» чи «Налаштування» (прототип v4 G:L7803–9700): стовпчик із проміжком 18px; заголовок
 * 22px/600 (−0.01em) з приглушеним підзаголовком, дії — праворуч, притиснуті до низу заголовка. Відступи дає основна область оболонки.
 */
export function SystemPage({ title, sub, actions, children, className }: ISystemPageProps) {
  return (
    <div className={cx('sp-page', className)}>
      <div className="sp-head">
        <div className="sp-head__titles">
          <h1>{title}</h1>
          {sub && <div className="sp-sub">{sub}</div>}
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}
